import React, {useState, useEffect} from 'react';
import FormSubmissionTwoStep from './form-submission-two-step';
import FormSubmissionConfirmationBox from './submission-confirmation-box';
import FormSubmissionPostSubmitJavascript from './form-submission-post-submit-javascript';
import FormNotificationsEmail from '../form-notifications-email';
import SubSection from '../../../libs/react-components-admin/section/sub-section';
import Storage from './storage';
import CloseModal from '../../../libs/react-components-admin/modal/close-modal';
import {RowWithButtonConfig} from '../../common/button-config';

const FormSubmission = ({initialModel, onChange, onSendTestEmail}) => {

  const [model, setModel] = useState(initialModel || {});

  useEffect(() => onChange(model), [model]);

  const updateModel = (fieldName, value) => {
    const updatedModel = {...model};
    updatedModel[fieldName] = value;
    setModel(updatedModel);
  };

  return <>
    <SubSection title="Form submission">
      <Storage initialModel={model.storage}
               onChange={v => updateModel('storage', v)}/>
      <button type="button"
              className="btn btn-sm btn-outline-dark px-4"
              onClick={() => CloseModal.showModal(
                <RowWithButtonConfig idPrefix="submit"
                                     value={model.button}
                                     onChange={v => updateModel('button', v)}/>
              )}>
        Open submit button settings
      </button>
      <FormSubmissionTwoStep model={model.twoStepSubmission}
                             onChange={v => updateModel('twoStepSubmission', v)}/>
      <SubSection title="Submission behavior">
        <div className="form-check">
          <input id="submissionBehaviorDisplayMessage" name="submissionBehavior"
                 type="radio"
                 className="form-check-input"
                 value="DISPLAY_MESSAGE"
                 checked={model.behavior === 'DISPLAY_MESSAGE'}
                 onChange={e => updateModel('behavior', e.target.value)} />
          <label className="form-check-label" htmlFor="submissionBehaviorDisplayMessage">
            Once the form is submitted, display a message
          </label>
        </div>
        {model.behavior === 'DISPLAY_MESSAGE' &&
        <div className="ms-md-4">
          <div className="mb-3">
            <label htmlFor="submissionConfirmationMessage" className="form-label">Confirmation message</label>
            <textarea id="submissionConfirmationMessage" name="submissionConfirmationMessage"
                      className="form-control" style={{height: '5em'}}
                      placeholder="e.g. <p>Thank you</p>"
                      value={model.confirmationMessage || ''}
                      onChange={e => updateModel('confirmationMessage', e.target.value)} />
          </div>
          <FormSubmissionConfirmationBox model={model.confirmationBox}
                                         onChange={v => updateModel('confirmationBox', v)} />
          <label className="form-label">Form state once submitted</label>
          <div className="row justify-content-end" style={{marginTop: '-10px'}}>
            <div className="col-11">
              <div className="form-check">
                <input id="formStateOnConfMessageDisabled" name="formStateOnConfMessage"
                       type="radio"
                       className="form-check-input"
                       value="DISABLED"
                       checked={model.formStateOnConfMessage === 'DISABLED'}
                       onChange={e => updateModel('formStateOnConfMessage', e.target.value)} />
                <label className="form-check-label" htmlFor="formStateOnConfMessageDisabled">
                  Disabled
                </label>
              </div>
              <div className="form-check">
                <input id="formStateOnConfMessageHidden" name="formStateOnConfMessage"
                       type="radio"
                       className="form-check-input"
                       value="HIDDEN"
                       checked={model.formStateOnConfMessage === 'HIDDEN'}
                       onChange={e => updateModel('formStateOnConfMessage', e.target.value)} />
                <label className="form-check-label" htmlFor="formStateOnConfMessageHidden">
                  Hidden
                </label>
              </div>
            </div>
          </div>
        </div>
        }
        <div className="form-check mt-3">
          <input id="submissionBehaviorRedirect" name="submissionBehavior"
                 type="radio"
                 className="form-check-input"
                 value="REDIRECT"
                 checked={model.behavior === 'REDIRECT'}
                 onChange={e => updateModel('behavior', e.target.value)} />
          <label className="form-check-label" htmlFor="submissionBehaviorRedirect">
            Once the form is submitted, redirect the user to another page
          </label>
        </div>
        {model.behavior === 'REDIRECT' &&
        <div className="ms-md-4">
          <RedirectUrl value={model.redirectionUrl} onChange={v => updateModel('redirectionUrl', v)}/>
        </div>
        }
      </SubSection>
      <FormSubmissionPostSubmitJavascript value={model.postSubmitJavascript}
                                          onChange={v => updateModel('postSubmitJavascript', v)} />
    </SubSection>
    <SubSection title="Email notifications" className="my-4">
      <FormNotificationsEmail model={model.email}
                              onChange={v => updateModel('email', v)}
                              onSendTestEmail={emailAddress => onSendTestEmail(emailAddress)}/>
    </SubSection>
  </>;
};

export default FormSubmission;

const RedirectUrl = ({value, onChange}) => {

  const [_value, setValue] = useState(value);
  const [valid, setValid] = useState(value);

  useEffect(() => {
    const isValid = !_value || _value.indexOf('http') === 0 || _value.indexOf('/') === 0;
    setValid(isValid);
    onChange(isValid ? _value : null);
  }, [_value]);

  return <div className="mb-3">
    <label htmlFor="submissionRedirectionUrl" className="form-label">URL to redirect to</label>
    <input id="submissionRedirectionUrl" name="submissionRedirectionUrl"
           type="text"
           className={`form-control${!valid ? ' is-invalid' : ''}`}
           placeholder="/pages/another-page"
           value={_value || ''}
           onChange={e => setValue(e.target.value)}/>
    {!valid && <div className="invalid-feedback">The URL must start with http or /</div>}
  </div>;
};
